import { Stack, Typography } from '@mui/material';

const policyText = [
  '고객은 서비스 이용 중 문제 발생 시 환불을 요청할 수 있습니다.',
  '환불을 원하는 고객은 웹사이트에 안내된 이메일 또는 고객센터를 통해 신청할 수 있습니다.',
  '환불 요청 시 환불 사유 등을 기재하여 접수해야 하며, 회사는 접수 후 10영업일 이내에 검토하여 고객에게 결과를 안내드립니다.',
  '환불과 관련한 결과를 정해진 기간 내에 통지하지 못하는 경우 회사는 고객에게 지연 사유를 통지합니다.',
  '환불이 승인되면 회사는 고객의 서비스 이용 이력에 따라 요금을 일할계산하여 남은 금액을 환불합니다.',
  '결제 당시 진행했던 결제 수단으로 환불을 진행하며, 이에 따라 발생하는 수수료는 고객이 부담해야 합니다.',
  '결제 당시 할인된 금액은 환불되지 않을 수 있으며, 연간 결제 고객은 위약금이 청구될 수 있습니다.',
];

export default function RefundPolicy() {
  return (
    <Stack gap={3} sx={{ borderRadius: 6, p: 4, bgcolor: 'white' }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center">
        환불 정책
      </Typography>
      {policyText.map((text, i) => (
        <Typography key={i} fontSize={18}>
          {i + 1}. {text}
        </Typography>
      ))}
    </Stack>
  );
}
